import { Switch, Route, BrowserRouter } from 'react-router-dom'
import ContextProvider from './contexts/Context'
import Mint from './pages/Mint'
import Main from './pages/Main'
import Vision from './pages/Vision'
import MyNFT from './pages/MyNFT'
// import BottomBar from './components/BottomBar'
import PitchDeck from './pages/PitchDeck'
import Detail from './pages/Detail'
import Marketplace from './pages/Marketplace'
import Withdraw from './pages/Withdraw'
import GamePlay from './pages/GamePlay'
// import MarketplaceComing from './pages/Marketplace-Coming'
import AuctionComing from './pages/Auction-Coming'
import RegisterInvestor from './pages/RegisterInvestor'
import AboutHolysharks from './pages/AboutHolysharks'
import Gallery from './pages/Gallery'
import Godly from './pages/Godly'
// import AboutMetaverse from './pages/AboutMetaverse'
// import AboutNFT from './pages/AboutNFT'

function Common() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact strict path='/' render={() => {
          return (
            <Main />
          )
        }} />
       
       <Route exact strict path='/vision' render={() => {
          return (
            <Vision/>
          )
        }} />

        <Route exact strict path='/genesis-mystery-box' render={() => {
          return (
            <Mint/>
          )
        }} />

        <Route exact strict path='/register-investor' render={() => {
          return (
            <RegisterInvestor />
          )
        }} />

        <Route exact strict path='/metaverse-game-play' render={() => {
          return (
            <GamePlay />
          )
        }} />
        <Route exact strict path='/pitch-deck' render={() => {
          return (
            <PitchDeck />
          )
        }} />

        <Route exact strict path='/my-nft' render={() => {
          return (
            <MyNFT/>
          )
        }} />

        {/* <Route exact strict path='/marketplace' render={() => {
          return (
            <MarketplaceComing />
          )
        }} /> */}
        <Route exact strict path='/marketplace' render={() => {
          return (
            <Marketplace />
          )
        }} />
        <Route exact strict path='/auction' render={() => {
          return (
            <AuctionComing />
          )
        }} />

        <Route exact strict path='/detail/:tokenId' render={() => {
          return (
            <Detail />
          )
        }} />

        <Route exact strict path='/withdraw' render={() => {
          return (
            <Withdraw />
          )
        }} /> 

        <Route exact strict path='/faq' render={() => {
          return (
            <AboutHolysharks />
          )
        }} /> 

         {/* <Route exact strict path='/about-nft' render={() => {
          return (
            <AboutNFT />
          )
        }} /> 
        
        <Route exact strict path='/about-metaverse' render={() => {
          return (
            <AboutMetaverse />
          )
        }} />  */}

        <Route exact strict path='/gallery' render={() => {
          return (
            <Gallery />
          )
        }} /> 

        <Route exact strict path='/godly' render={() => {
          return (
            <Godly />
          )
        }} />

      </Switch>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <ContextProvider>
      <Common />
    </ContextProvider>
  );
}
